module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-6"
  }, [_c('Invoice', {
    attrs: {
      "invoice": _vm.invoice
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pdfcrowd-remove mt-5",
    attrs: {
      "href": "//pdfcrowd.com/url_to_pdf/",
      "target": "_blank"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "rounded": ""
    }
  }, [_vm._v("\n            Save to PDF\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-503a7874"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Billing/OneInvoice.vue
// module id = 2542
// module chunks = 1